var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthorization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 792,
    height: 588,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.001 334.888v7.699a455.98 455.98 0 0 1 9.384-11.823c-4.476 1.211-7.68 3.201-9.384 4.095v.029ZM82.001 582.002v4.181h325.231c-.751-1.413-1.617-2.797-2.396-4.181H82.001Z",
    fill: "#5C5291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.85 492.874c-2.599-54.757-43.917-99.365-97.188-107.15a34.335 34.335 0 0 0 1.443-11.736c-.895-18.022-15.996-32.583-34.07-32.814a34.155 34.155 0 0 0-17.96 4.786c-16.573-16.926-29.999-17.502-38.661-15.138a374.81 374.81 0 0 0-9.384 11.822v239.445h322.834c-26.419-46.251-72.53-79.815-126.985-89.157l-.029-.058Z",
    fill: "#5C5291"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M512.967 492.874c2.598-54.758 43.916-99.365 97.188-107.15a34.336 34.336 0 0 1-1.444-11.736c.895-18.022 15.996-32.584 34.071-32.814a34.154 34.154 0 0 1 17.959 4.786c16.92-17.301 30.577-17.502 39.21-14.994-72.414-87.427-181.845-143.136-304.355-143.136-122.51 0-231.797 55.651-304.211 142.992 8.662-2.336 22.088-1.788 38.661 15.138 5.255-3.085 11.405-4.873 17.96-4.786 18.074.259 33.175 14.792 34.07 32.814a34.311 34.311 0 0 1-1.443 11.736c53.3 7.814 94.589 52.421 97.188 107.15 48.45 8.304 90.258 35.813 117.515 74.336 27.257-38.552 69.123-66.032 117.602-74.336h.029Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.864 582.002c-2.916-5.103-6.121-10.034-9.499-14.792-4.302 6.084-8.258 12.399-11.809 19.002h325.231v-4.181H404.835l.029-.029Z",
    fill: "#5C5291"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M708.816 582.002V342.039a406.406 406.406 0 0 0-8.864-11.13c-8.634-2.509-22.291-2.307-39.211 14.994-5.255-3.086-11.405-4.873-17.959-4.787-18.075.26-33.176 14.792-34.071 32.814a34.333 34.333 0 0 0 1.444 11.736c-53.301 7.814-94.59 52.422-97.188 107.15-48.479 8.305-90.345 35.813-117.602 74.336 3.378 4.787 6.583 9.689 9.499 14.793h303.952v.057Z",
    fill: "#7262CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.92 305.793c-.491.952-.982 1.904-1.444 2.884-6.121-3.604-13.253-5.652-20.876-5.536-21.019.288-38.575 17.185-39.614 38.148a40.4 40.4 0 0 0 1.675 13.668c-61.934 9.054-109.951 60.928-112.982 124.566-65.226 11.188-120.23 52.191-150.402 108.506H767.92V305.793Z",
    fill: "#F1F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M82.001 586.212h325.231c-25.957-48.442-73.281-83.736-129.382-93.338-2.599-54.758-43.917-99.365-97.188-107.15a34.335 34.335 0 0 0 1.443-11.736c-.895-18.022-15.996-32.584-34.07-32.814a34.157 34.157 0 0 0-17.96 4.786c-25.148-25.691-43.079-13.667-48.045-11.043v251.324l-.029-.029Z",
    fill: "#7262CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m438.416 319.923-36.352 6.228-36.352-6.228S368.715 572.631 271.151 588h261.854c-97.563-15.34-94.561-268.077-94.561-268.077h-.028Z",
    fill: "#F1F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.277 307.725h47.958v-20.588l-47.958-60.784v81.372Z",
    fill: "#AF2727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m444.277 233.476 47.958 60.063v14.186l-47.958.029v-74.278ZM358.349 307.725h-47.988v-20.588l47.988-60.784v81.372Z",
    fill: "#7D1414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m358.349 233.476-47.988 60.063v14.186l47.988.029v-74.278Z",
    fill: "#A33D21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.313 91.695c-21.684 0-41.925-4.614-59.104-12.63l15.851 228.689c12.56 8.016 21.569 12.63 43.253 12.63s30.692-4.614 43.252-12.63l15.852-228.689c-17.18 8.016-37.42 12.63-59.104 12.63Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.832 189.358 1.645 23.904c15.015 5.594 31.906 8.737 49.807 8.737 17.902 0 34.793-3.143 49.807-8.737l1.646-23.904c-15.419 5.998-32.916 9.372-51.453 9.372-18.537 0-36.034-3.403-51.452-9.372Z",
    fill: "#5C5291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.022 158.25c4.171-17.736-6.843-35.491-24.602-39.657-17.76-4.166-35.538 6.834-39.71 24.569-4.172 17.736 6.842 35.49 24.602 39.657 17.759 4.166 35.538-6.834 39.71-24.569Z",
    fill: "#61579C",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.877 170.79c12.899-12.882 12.899-33.768 0-46.651-12.9-12.882-33.814-12.882-46.714 0-12.899 12.883-12.899 33.769 0 46.651 12.9 12.882 33.814 12.882 46.714 0Z",
    fill: "#AF2727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.573 180.448-.202-65.945c-18.191.087-32.887 14.821-32.887 32.987 0 18.166 14.783 32.987 33.031 32.987h.058v-.029Z",
    fill: "#7D1414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.016 151.304c2.119-14.046-7.565-27.149-21.63-29.266-14.065-2.117-27.186 7.554-29.306 21.6-2.119 14.047 7.565 27.15 21.63 29.267 14.065 2.117 27.186-7.554 29.306-21.601Z",
    fill: "#5C5291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.544 173.182-.145-51.441c-14.176.057-25.639 11.562-25.639 25.72s11.52 25.721 25.755 25.721h.029Z",
    fill: "#443D6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.515 121.741c-6.468 0-12.358 2.393-16.891 6.315a25.689 25.689 0 0 1 13.224-3.634c14.235 0 25.755 11.505 25.755 25.721 0 7.757-3.436 14.706-8.864 19.406 7.507-4.498 12.531-12.687 12.531-22.088 0-14.215-11.52-25.72-25.755-25.72Z",
    fill: "#8879D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.4 121.741a25.624 25.624 0 0 0-16.776 6.315 25.689 25.689 0 0 1 13.224-3.634c1.213 0 2.397.116 3.58.289v-2.941l-.028-.029Z",
    fill: "#5C5291"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m401.313 0-13.34 8.362c-27.574 17.301-44.234 41.609-45.678 67.474a62.747 62.747 0 0 0-.086 3.23v3.805c17.179 5.594 37.42 8.824 59.104 8.824 21.684 0 41.924-3.23 59.104-8.824v-3.806c0-1.038-.029-2.105-.087-3.23-1.415-25.864-18.103-50.172-45.678-67.473L401.313 0Z",
    fill: "#7D1414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.175 91.032c15.303-1.212 29.595-4.037 42.213-8.16v-3.807c0-1.038-.029-2.105-.087-3.23-1.414-25.864-18.103-50.172-45.677-67.473L401.284 0s-62.396 92.56 16.891 91.032Z",
    fill: "#AF2727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.832 319.951 396 230.506l-19.894 86.533c4.245 1.413 8.98 2.393 14.726 2.912Z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.209 291.29h-22.377L396 230.506h12.04l5.169 60.784ZM413.209 291.29h-22.377v28.719c3.436.231 6.929.375 10.481.375 4.013 0 7.998-.173 11.925-.461V291.29h-.029Z",
    fill: "#7D1414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.035 320.384c3.782 0 7.507-.173 11.203-.461V291.29h-11.203v29.094ZM402.035 291.29h11.174l-5.169-60.784h-6.005v60.784Z",
    fill: "#AF2727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.313 320.384c-17.497 0-26.737-3.028-36.265-8.391l.837 11.966c10.914 4.066 23.186 6.344 36.15 6.344 12.964 0 25.264-2.278 36.149-6.344l.896-12.831c-10.077 5.911-19.346 9.256-37.767 9.256Z",
    fill: "#7D1414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.313 91.695c-21.684 0-41.925-4.614-59.104-12.63l15.851 228.689c12.56 8.016 21.569 12.63 43.253 12.63h.693l-.693-228.69Z",
    fill: "#61579C",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.189 305.793c.49.952.981 1.904 1.443 2.884 6.121-3.604 13.253-5.652 20.876-5.536 21.02.288 38.575 17.185 39.614 38.148a40.417 40.417 0 0 1-1.674 13.668c61.933 9.054 109.95 60.928 112.981 124.566 65.226 11.188 120.23 52.191 150.403 108.506H26.188V305.793Z",
    fill: "#F1F6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.209 143.799c4.513 0 8.171-3.653 8.171-8.16s-3.658-8.16-8.171-8.16-8.171 3.653-8.171 8.16 3.658 8.16 8.171 8.16Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.099 186.36c0-.202.029-.404.029-.606 0-7.641-6.208-13.841-13.86-13.841-1.905 0-3.724.375-5.37 1.096-.982-11.361-10.51-20.271-22.117-20.271a22.166 22.166 0 0 0-20.529 13.726 17.684 17.684 0 0 0-5.833-1.01c-9.672 0-17.497 7.815-17.497 17.474 0 1.182.115 2.336.346 3.432h84.86-.029ZM659.5 33.621c0-.201.028-.403.028-.605 0-7.641-6.207-13.84-13.859-13.84-1.906 0-3.725.374-5.37 1.095C639.317 8.91 629.789 0 618.182 0a22.166 22.166 0 0 0-20.529 13.725 17.7 17.7 0 0 0-5.833-1.009c-9.673 0-17.497 7.814-17.497 17.474 0 1.182.115 2.336.346 3.431h84.859-.028ZM134.002 155.362c0-.202.029-.404.029-.605 0-7.642-6.208-13.841-13.859-13.841-1.906 0-3.725.375-5.371 1.096-.982-11.361-10.51-20.271-22.117-20.271a22.166 22.166 0 0 0-20.529 13.725 17.706 17.706 0 0 0-5.832-1.009c-9.673 0-17.498 7.814-17.498 17.474 0 1.182.116 2.335.347 3.431h84.859-.029Z",
    fill: "#7262CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.313 213.291a2.828 2.828 0 0 0 2.829-2.826 2.827 2.827 0 0 0-2.829-2.825 2.828 2.828 0 0 0-2.83 2.825 2.828 2.828 0 0 0 2.83 2.826ZM423.343 211.417a2.828 2.828 0 0 0 2.83-2.826 2.828 2.828 0 0 0-2.83-2.826 2.828 2.828 0 0 0-2.83 2.826 2.828 2.828 0 0 0 2.83 2.826ZM444.248 204.785a2.833 2.833 0 0 1-2.83 2.826 2.833 2.833 0 0 1-2.83-2.826 2.833 2.833 0 0 1 2.83-2.826 2.833 2.833 0 0 1 2.83 2.826ZM362.045 207.611a2.828 2.828 0 0 0 2.829-2.826 2.828 2.828 0 0 0-2.829-2.826 2.828 2.828 0 0 0-2.83 2.826 2.828 2.828 0 0 0 2.83 2.826ZM380.033 211.417a2.828 2.828 0 0 0 2.83-2.826 2.828 2.828 0 0 0-2.83-2.826 2.828 2.828 0 0 0-2.83 2.826 2.828 2.828 0 0 0 2.83 2.826ZM227.581 121.741l-6.785-19.81-12.272-6.574 12.185-6.776 6.612-19.868 6.756 19.781 12.272 6.603-12.185 6.748-6.583 19.896ZM625.14 281.832l-6.785-19.81-12.272-6.574 12.185-6.776 6.612-19.868 6.757 19.781 12.271 6.603-12.185 6.748-6.583 19.896ZM216.205 323.066l-3.869-11.361-7.045-3.807 6.987-3.863 3.782-11.419 3.898 11.361 7.045 3.777-6.987 3.893-3.811 11.419ZM10.943 60.755l-3.898-11.36L0 45.587l6.987-3.864 3.783-11.419 3.898 11.361 7.045 3.778-6.988 3.892-3.782 11.419ZM505.488 396.537l-3.898-11.361-7.045-3.806 6.988-3.864 3.811-11.419 3.869 11.361 7.045 3.777-6.987 3.893-3.783 11.419ZM544.554 146.827l-3.234-9.487-5.919-3.172 5.862-3.258 3.176-9.573 3.263 9.515 5.89 3.172-5.862 3.259-3.176 9.544ZM782.991 127.219l-3.262-9.515-5.919-3.172 5.861-3.258 3.176-9.545 3.263 9.516 5.89 3.172-5.861 3.258-3.148 9.544ZM313.913 427.851l-3.321-9.717-6.006-3.258 5.977-3.316 3.234-9.775 3.321 9.746 6.034 3.229-5.977 3.316-3.262 9.775Z",
    fill: "#F0D769"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 395.683,
    y1: -177.132,
    x2: 395.683,
    y2: 430.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FCE28B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#E8D085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#B19F75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#847669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#61575F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#484057"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#393253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#342E52"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h792v588H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorization);
export default __webpack_public_path__ + "static/media/authorization.7a0768f17f58fb8b1d27413639a3552d.svg";
export { ForwardRef as ReactComponent };